import React from "react"
import { Router } from "@reach/router"
import Layout from "../components/layout"
import Account from "../components/bigcommerce/account/Account"
import Login from "../components/bigcommerce/account/Login"
import Register from "../components/bigcommerce/account/Register"
import PrivateRoute from "../components/bigcommerce/account/PrivateRoute"
import SEO from "../components/seo"
import PublicRoute from "../components/bigcommerce/account/PublicRoute"

const App = props => {
  const str = props.params["*"] || ""
  return (
    <Layout>
      <SEO title={str?.charAt(0).toUpperCase() + str?.slice(1)} />
      <Router>
        <PrivateRoute component={Account} path="/app/account" />
        <PublicRoute component={Login} path="/app/login" />
        <PublicRoute component={Register} path="/app/register" />
      </Router>
    </Layout>
  )
}

export default App
